import React from 'react';
import { cn } from '../../utils/cn';

export interface CardProps extends React.HTMLAttributes<HTMLElement> {
  as?: 'div' | 'section' | 'article' | 'li';
  padding?: 'none' | 'sm' | 'md' | 'lg';
  interactive?: boolean;
  /** Shadow is reserved for the notification/listing card; leave false elsewhere. */
  elevated?: boolean;
}

const paddingClasses: Record<NonNullable<CardProps['padding']>, string> = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-6',
};

export const Card = React.forwardRef<HTMLElement, CardProps>(
  ({ as = 'div', padding = 'md', interactive, elevated, className, ...rest }, ref) => {
    const Tag = as as React.ElementType;
    return (
      <Tag
        ref={ref}
        className={cn(
          'bg-card border border-line rounded-card',
          paddingClasses[padding],
          elevated && 'shadow-card',
          interactive && 'transition-shadow hover:shadow-card cursor-pointer',
          className
        )}
        {...rest}
      />
    );
  }
);
Card.displayName = 'Card';
